export default {
  link: "",
  image_file_uz: "",
  image_file_oz: "",
  image_file_ru: "",
  image_file_en: "",
  image_file_tj: "",
  image_file_kz: ""
}
